'use strict';

// jQuery pateikiamas globaliai per webpack ProvidePlugin ($, jQuery, window.jQuery)

// Bibliotekos is npm (versijos - dev/package.json, tos pacios kaip EW4 bazeje)
import 'slick-slider';
import 'tooltipster';
import '@fancyapps/fancybox';
import 'select2';
import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_lt';
import 'jquery.highlight-bartaz';
import imagesLoaded from 'imagesloaded'; // getMoreNews/getMoreVideos: laukia paveiksleliu pries lygiuojant aukscius
import 'angular';

// pikaday (formu datos laukai .datepicker) su dayjs lokalizacija
import dayjs from 'dayjs';
import dayjsCustomParseFormat from 'dayjs/plugin/customParseFormat';
import dayjsLocaleData from 'dayjs/plugin/localeData';
import 'dayjs/locale/lt';
import 'dayjs/locale/ru';
dayjs.extend(dayjsCustomParseFormat);
dayjs.extend(dayjsLocaleData);
dayjs.locale('lt');
if (document.documentElement.lang) {
	dayjs.locale(document.documentElement.lang);
}
import Pikaday from 'pikaday';
import 'pikaday/css/pikaday.css';

// Bibliotekos, kuriu nera npm (vendorintos, tos pacios kaip EW4 bazeje dev/src/js/lib)
import '../lib/mmenu_old_version/js/mmenu.js';
import '../lib/lightgallery/js/lightgallery.ew4.js';
import '../lib/jquery-nicefileinput/jquery.nicefileinput.js';
import '../lib/javascript-equal-height-responsive-rows/grids.js';

// Globalus jQuery inline skriptams sablonuose (component_infographic.tpl, collectors onload) ir js/blocks/blocks.js
window.$ = window.jQuery = $;

$(document).ready(function () {
	if (!$("#popup_window").length) { // init if not in dialog view
		select2();
		fancybox();
		validate();
		slick_carousel();
		mobile_sidebar();
		gallery_hash();
		youtube_hash();
		videogallery_search_popup();
		fixed_header();
		print_v();
		highlight_search_results();
		new init_questions_toggler_hash(); // naudoja this.* -> strict mode reikia new
		catalog_gallery();
		file_input();
		iframe_adaptability();
		reportbug_form();
		show_more();
		postformwidget_validate();
		init_contacts();
		tooltipster();
		recaptcha_v3();
		pikaday();

		sidebar_menu();
		scroll_top();

		set_widgetcalendar_data();
		showDayEvent();
		EventCalendar();
		toggle_items();
		loadTitlepageCalendar();
	}
});

$(window).on('load', function () {
	$('.equalheight').responsiveEqualHeightGrid();
	if ($(window).width() < 768) {
		mobile_overflow_tables();
	}
	add_label_to_mobile_menu_buttons();
	setTimeout(function () {
		$('.main_content .content-box.hidden').removeClass('hidden');
		$('.main_layout .loader').remove();
	}, 1000);
});

function select2() {
	$("select").select2({
		"minimumResultsForSearch": -1
	});

	// use this class if placeholder is needed. 
	// Translation added as data attribute: <select data-placeholder="{'choise_value'|t}">
	// Also, first option in select element has to be empty: <option value=""></option>
	$("select.select2_with_dynamic_placeholder").select2({
		"minimumResultsForSearch": -1,
		placeholder: function () {
			$(this).data('placeholder');
		}
	});
}


function slick_carousel() {
	// Slick carousel docs:
	//http://kenwheeler.github.io/slick/

	if ($("#title_slides").length) {
		$('#title_slides').slick({
			dots: true,
			arrows: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			rows: 0
		});

		$('#title_slides').on('afterChange', function (event, slick, currentSlide, nextSlide) {
			//console.log(slick);
		});
	}

	if ($(".promoblock_slider").length) {
		$('.promoblock_slider').slick({
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 6,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 5,
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 420,
					settings: {
						slidesToShow: 2,
					}
				}],
			slidesToScroll: 1,
			speed: 180,
			cssEase: 'linear',
			rows: 0
		});
	}
}


function fancybox() {
	// FB3 docs: https://fancyapps.com/fancybox/3/docs
	//  Translations inside libs/localization/

	// News preview
	$("a.news_image").fancybox({
		btnTpl: {
			zoom: false
		}
	});

	// News gallery 
	$("a.fancybox_gallery").fancybox({
		thumbs: false,
		transitionEffect: "slide",
		clickContent: false,
		btnTpl: {
			zoom: false
		}
	});

	// From Tinymce
	$("a[rel=fancybox]").fancybox({
		btnTpl: {
			zoom: false
		}
	});

	// Ajax call
	$("a.fancybox_ajax").fancybox({
		type: "ajax",
		touch: false // disable drag cursor
	});

	// Iframe call
	$("a.fancybox_iframe").fancybox({
		type: "iframe",
		touch: false // disable drag cursor
	});
}

function gallery_popup() {
	$('.gallery_popup').on("click", function () {
		$(".album_loading").show();
		var $this = $(this);
		var url = $(this).data("fancy-link");
		$.ajax({
			url: url,
			type: "GET",
			success: function (data) {
				$(".album_loading").fadeOut("fast");
				var photos = [];
				$.each(data.photos, function (i) {
					var obj = {
						"src": this.img_itemimage,
						"thumb": this.img_itemimage_thumb
					};
					if (this.title) {
						obj.subHtml = '<div class="photo_title">' + this.title + '</div>';
					}
					photos.push(obj);
				});
				$this.lightGallery({
					dynamic: true,
					dynamicEl: photos,
					speed: 300,
					hideBarsDelay: 1000,
					closable: false,
					loop: false,
					download: false,
					enableDrag: false,
					thumbWidth: 112,
					thumbContHeight: 83,
					thumbMargin: 10,
					toogleThumb: false,
					galleryId: $this.data("id")
				});
				$this.on('onAfterOpen.lg', function (event, index, fromTouch, fromThumb) {
					$(".lg").append("<div class='album_title lg-toolbar'><div class='album_title_text'>" + data.title + "</div></div>")
				});
			},
			error: function () {
				$(".album_loading").fadeOut("fast");
				alert('Load error.');
			}
		});


	});
}

function youtube_popup() {
	$('.youtube_popup').on("click", function () {

		$(".album_loading").show();
		var $this = $(this);
		var url = $(this).data("fancy-link");
		$.ajax({
			url: url,
			type: "GET",
			success: function (data) {
				$(".album_loading").fadeOut("fast");
				var photos = [];
				var obj = {
					"src": data.youtube_share_link,
					"thumb": data.img_itemimage_thumb,
					//"poster":  data.img_itemimage_thumb
				};
				if (data.title) {
					obj.subHtml = '<div class="photo_title">' + data.title + '</div>';
				}
				photos.push(obj);
				$this.lightGallery({
					dynamic: true,
					dynamicEl: photos,
					speed: 300,
					hideBarsDelay: 1000,
					closable: false,
					loop: false,
					download: false,
					enableDrag: false,
					thumbWidth: 112,
					thumbContHeight: 83,
					thumbMargin: 10,
					toogleThumb: false,
					//youtubePlayerParams: {autoplay:0 },
					counter: false,
					videoMaxWidth: '900px',
					addClass: "youtubegallery_popup",
					fullScreen: false
				});
			},
			error: function () {
				$(".album_loading").fadeOut("fast");
				alert('Load error.');
			}
		});


	});
}


function validate() {
	var options = {
		highlight: function (element, errorClass, validClass) {
			if ($(element).closest(".type_item").length) {
				$(element).closest(".type_item").removeClass(validClass).addClass(errorClass);
			}
		},
		unhighlight: function (element, errorClass, validClass) {
			if ($(element).closest(".type_item").length) {
				$(element).closest(".type_item").removeClass(errorClass).addClass(validClass);
			}
		},
		errorPlacement: function (error, element) {
			$(element).closest(".type_item").find('.type_error').append(error);
		},
	}
	if ($("#forms_form").length) {
		$("#forms_form").validate(options);
		$("#forms_form select").change(function () {
			$(this).valid();
		});
		$("#forms_form input[type='file']").change(function () {
			$(this).valid();
		});
	}
	if ($("#letter_form").length) { // Postform
		$("#letter_form").validate(options);
	}
	if ($("#poll_form").length) {
		$("#poll_form").validate(options);
		$("#poll_form select").change(function () {
			$(this).valid();
		});
		$("#poll_form input[type='file']").change(function () {
			$(this).valid();
		});
	}
	if ($("#subscription_form").length) {
		$("#subscription_form").validate(options);
	}
	if ($("#poll_widget").length) {
		$("#poll_widget").validate(options);
	}
	if ($("#sitelogin_widget").length) {
		$("#sitelogin_widget").validate(options);
	}
	if ($("#duk_form").length) {
		$("#duk_form").validate(options);
	}
	if ($(".comment-form").length) {
		$(".comment-form").validate(options);
	}
	if ($("#sitelogin_form").length) {
		$("#sitelogin_form").validate(options);
	}
	if ($("#faq_form").length) {
		$("#faq_form").validate(options);
	}
	if ($("#subscription_form_index").length) {
		$("#subscription_form_index").validate(options);
	}
	if ($("#remind_pass_form").length) {
		$("#remind_pass_form").validate(options);
	}

	if ($('#custom_validate').length) {
		$("#custom_validate").validate(options);
		$("#custom_validate select").change(function () {
			$(this).valid();
		});
		$("#custom_validate input[type='file']").change(function () {
			$(this).valid();
		});
	}
}


function mobile_sidebar() {
	var $m = $("#mobile_menu").mmenu({
		"extensions": [
			"border-full",
			"theme-white"
		],
		"offCanvas": {
			"position": "left"	//meniu sliding from right side
		},
		"counters": false,
		"slidingSubmenus": false,
//		"navbar": {
//			"title": " "
//		},
//		"navbars": [
//			{
//				"position": "top",
//			}
//		]
	}, {
		selectedClass: "active"
	});

	$(window).bind("pageshow", function (event) {
		if (event.originalEvent.persisted) { //bugfix - iphone safari history state leaves menu open. Close it!
			setTimeout(function () {
				var API = $m.data("mmenu");
				API.close();
			}, 50);
		}
	});
}

/**
 * Creates new hashchange event callback
 * 
 * @param {Object} arg = {callback: callback_function, rule: {RegExp|String}, bubbling: {true|false}}  
 * @param {Object} hashControllerObj
 * @returns {null|hashCallBack}
 */
function hashCallBack(arg, hashControllerObj) {
	this.callback;
	this.bubbling = false;
	this.rule = null;
	this.hashObj = hashControllerObj;
	this.lock = false;
	var self = this;

	/**
	 * Constructor
	 * @param {Object} arg
	 * @returns {hashCallBack|null}
	 */
	this.init = function (arg) {
		if (this.setCallback(arg.callback)) {
			if (arg.bubbling) {
				this.bubbling = arg.bubbling;
			}
			this.setRule(arg.rule);
			window.addEventListener("hashchange", self.call, this.bubbling);
			return this;
		}
		return null;
	};

	/**
	 * 
	 * @param {Event} e
	 * @returns {null|String} callback response | null
	 */
	this.call = function (e) {
		if (self.checkRule(self.hashObj.get()) && !self.lock) {
			return self.callback(e, self);
		}
		return null;
	};

	/**
	 * Check if event callback will be executed
	 * @param {String} str hash string to test rule
	 * @returns {Boolean}
	 */
	this.checkRule = function (str) {
		return (!this.rule || this.rule.test(str));
	};

	/**
	 * Set event callback execution rule.
	 * @param {String|RegExp} rule
	 */
	this.setRule = function (rule) {
		if (typeof (rule) !== 'undefined' && rule != '') {
			if (typeof (rule) !== 'object') {
				this.rule = new RegExp(rule);
			} else {
				this.rule = rule;
			}
		}
	};

	/**
	 * 
	 * @param {String|Function} callback
	 * @returns {Boolean} Return true if callback is valid function, otherwise - false
	 */
	this.setCallback = function (callback) {
		if (typeof (callback) === 'string') {
			if (typeof (window[callback]) === 'function') {
				this.callback = window[callback];
				return true;
			}
			return false;
		} else if (typeof (callback) === 'function') {
			this.callback = callback;
			return true;
		}
		return false;
	};

	return this.init(arg);
}
;

/**
 * hashChange event controller
 * @example register hashController.register({
 *			callback: (function(){} | "functioNname" | object.method),
 *			rule: (new RegExp("^[a-z]+$", "i") | "^[a-z]+$"),
 *			bubbling: false
 * });
 * @type hashController
 */
var hashController = new function () {

	this.db = new Array();
	var self = this;
	/**
	 * 
	 * @param {Object} callbackParams {
	 *			callback: (function(){} | "functioNname" | object.method),
	 *			rule: (new RegExp("^[a-z]+$", "i") | "^[a-z]+$"),
	 *			bubbling: false
	 * }
	 * @returns {hashCallBack}
	 */
	this.register = function (callbackParams) {
		var cb = new hashCallBack(callbackParams, this);
		self.db.push(cb);
		return cb;
	};

	/**
	 * 
	 * @returns {string} hash string without '#'
	 */
	this.get = function () {
		return location.hash.replace(/^#/, '');
	};

	this.set = function (hash) {
		location.hash = hash;
	};

	this.clear = function () {
		//this.set(''); // deleted, because jumps to top page 
		history.replaceState({}, document.title, location.pathname);
	};

	this.replace = function (hash) {
		history.replaceState({}, document.title, location.pathname + '#' + hash);
	};

	this.trigger = function () {
		for (var i = 0; i < self.db.length; i++) {
			if (document.createEvent) {
				var e = document.createEvent("Event");
				e.initEvent("hashchange", true, true);//,window,0,0,0,0,0,false,false,false,false,0,null);
			} else {
				var e = new Event('hashchange', {});
			}
			self.db[i].call(e);
		}
	};

};
/**
 * Alias for hashController
 * @type @exp;hashController
 */
var hc = hashController;

/**
 * @example hc.register({callback: function(e, h){
 *			console.log(h.get());
 *		}});
 *
 *		hc.set('raudona');
 */

$(document).ready(function () {
	hc.trigger();
});

function galleryWrapper() {
	this.photos = new Array();
	this.album_data;
	this.album_id;
	this.photo_id = '';
	this.dataUrl = '';
	this.isOpen = false;
	this.base_url = location.pathname + '/';
	this.hcb;

	this.gallery_options = {
		dynamic: true,
		speed: 300,
		hideBarsDelay: 2000,
		closable: false,
		loop: true,
		download: false,
		enableDrag: false,
		thumbWidth: 112,
		thumbContHeight: 93,
		thumbMargin: 10,
		showAfterLoad: false,
		toogleThumb: false,
		galleryId: this.album_id
	};

	if (arguments[0] && typeof (arguments[0]) === 'object') {
		$.extend(this.gallery_options, arguments[0]);
	}

	var self = this;

	this.getElement = function () {
		if (!document.getElementById(this.album_id)) {
			$('body').append('<div id="' + this.album_id + '" style="display:none;"></div>');
		}
		return $('#' + this.album_id);
	};

	this.init = function () {
		if (!this.isOpen) {
			$(".album_loading").show();
			$.ajax({
				url: this.dataUrl,
				type: "GET",
				dataType: "json",
				contentType: "application/json",
				success: function (data) {
					self.album_data = data;
					self.setPhotos(data);
					if (self.photos.length > 0) {
						self.initgallery();
						$(".album_loading").fadeOut("fast");
					} else {
						$(".album_loading").fadeOut("fast");
						self.close();
					}
				},
				error: function () {
					$(".album_loading").fadeOut("fast");
					alert('Load error.');
				}
			});
		}
	};

	this.setPhotos = function (data) {
		if (typeof (data.photos) !== 'undefined') {
			for (var i = 0; i < data.photos.length; i++) {
				var obj = {
					src: ($(window).width() > 800 ? data.photos[i].img__original : data.photos[i].img_itemimage)
				};
				if (typeof (data.photos[i].img_itemimage_thumb) !== 'undefined') {
					obj.thumb = data.photos[i].img_itemimage_thumb;
				} else {
					obj.thumb = data.photos[i].img_listimage;
				}
				if (data.photos[i].title) {
					obj.subHtml = '<div class="photo_title">' + data.photos[i].title + '</div>';
				}
				self.photos.push(obj);
			}
		}
	};

	this.initgallery = function () {
		var cont = this.getElement();
		if (this.photo_idx > 0 && this.photos.length > this.photo_idx) {
			this.gallery_options.index = this.photo_idx;
		}
		this.gallery_options.dynamicEl = this.photos;
		this.gallery_options.galleryId = this.album_id;
		$(cont).lightGallery(this.gallery_options);
		this.isOpen = true;
		this.galleryEvents(cont);
	};

	this.galleryEvents = function (cont) {
		$(cont).on('onAfterOpen.lg', function () {
			if ($("#album_title").length) {
				$("#album_title").html(self.album_data.title);
			} else {
				$(".lg").append("<div class='album_title lg-toolbar'><div id='album_title' class='album_title_text'>" + self.album_data.title + "</div></div>");
			}
			if (!$(".gallery_share").length) {
				$(".lg-toolbar.group").append("<div class='gallery_share'><div class='share_icon'></div><div class='share_drop'><div class='share_fb'></div><div class='share_gplus'></div></div></div>");
				//$("<div class='gallery_share'><div class='share_icon'></div><div class='share_drop'><div class='share_fb'></div><div class='share_gplus'></div></div></div>").insertAfter(".lg-fullscreen");

				$(".lg-outer").on("click", function () {
					$(".share_drop").slideUp("fast");
					$(".share_icon").removeClass("active");
				});
				$(".share_icon").on("click", function (e) {
					$(this).addClass("active");
					e.stopPropagation();
					$(this).parent().find(".share_drop").slideToggle("fast");
				});

				$(".share_fb").on("click", function (e) {
					$(".share_drop").slideUp("fast");
					$(".share_icon").removeClass("active");
					window.open("https://www.facebook.com/sharer/sharer.php?u=" + escape(window.location.href), 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
					return false;
				});
				$(".share_gplus").on("click", function (e) {
					$(".share_drop").slideUp("fast");
					$(".share_icon").removeClass("active");
					window.open("https://plus.google.com/share?url=" + escape(window.location.href), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
					return false;
				});
			}
			if (self.photo_idx > 0) {
				$(cont).data('lightGallery').slide(self.photo_idx);
			}
		});
		$(cont).on('onCloseAfter.lg', function () {
			self.hcb.hashObj.clear();
			self.close();
		});
		$(cont).on('onAfterSlide.lg', function (event, index, fromTouch, fromThumb) {
			self.hcb.hashObj.replace('!' + self.album_id + '/photo' + $(cont).data('lightGallery').index);
//			setTimeout(function(){self.ignore(false);}, 50);
		});
	};

	this.route = function (e, hcb) {
		this.hcb = hcb;
		var parts = this.hcb.hashObj.get().replace(/^\!/, '').split('/');
		this.album_id = parts[0];

		this.dataUrl = this.getUrl();

		this.ignore(true);
		if (parts.length > 1 && /^photo[0-9]+$/.test(parts[1])) {// && typeof(this.photos_index[parts[1]]) !== 'undefined'){
			var nr = parts[1].replace(/^photo([0-9]+)$/, '$1');
			if (!this.isOpen && this.photo_idx != nr) {
				this.photo_idx = parseInt(nr);
			}
//			else if(this.isOpen){
//				var cont = this.getElement();
//				console.log(parseInt(nr));
//				$(cont).data('lightGallery').slide(parseInt(nr));
//			}
		}
		if (!this.isOpen) {
			this.init();
		}
	};

	this.close = function () {
		this.ignore(false);
		this.photos = new Array();
		this.album_data = null;
		this.album_id = '';
		this.dataUrl = '';
		this.photo_idx = '';
		this.isOpen = false;
		//this.hcb = null;
	};

	this.ignore = function () {
		this.hcb.lock = !!arguments[0];
	};
	this.isIgnored = function () {
		return !!this.hcb.lock;
	};
	this.getUrl = function () {
		var url = this.getElement().data('url');
		if (!url || url === '') {
			url = this.base_url + this.album_id;//location.pathname + '/albumdata/' + this.album_id;
		}
		return url;
	};
	//this.route();
}
;

function gallery_hash() {
	var wr = new galleryWrapper();
	wr.base_url = location.pathname + '/albumdata/';
	hc.register({
		callback: function (e, hcb) {
			wr.route(e, hcb);
		},
		rule: new RegExp("^\!album[0-9]+(/photo[0-9]+)*$")
	});
	$('.gallery_list, .search_results, .assoc_gallery_cont').on("click", ".gallery_popup", function () {
		location.hash = '!' + $(this).attr('id');
	});

}

function youtube_hash() {

	var wry = new galleryWrapper({
		loop: false,
		youtubePlayerParams: {
			//autoplay: 0,
			rel: 0/*,
			 showinfo: 0*/
		},
		counter: false,
		videoMaxWidth: '900px',
		addClass: "youtubegallery_popup",
		fullScreen: false
	});

	wry.base_url = location.pathname + '/itemdata/';

	wry.setPhotos = function (data) {
		var obj = {
			src: data.youtube_share_link,
			thumb: data.imgthumbnail//,
					//poster: data.imgposter // reikalingas jei norim autoplay=0
		};
		if (data.title) {
			obj.subHtml = '<div class="photo_title">' + data.title + '</div>';
		}
		wry.photos.push(obj);
	};

	wry.galleryEvents = function (cont) {
		$(cont).on('onCloseAfter.lg', function () {
			wry.hcb.hashObj.clear();
			wry.close();
		});
	};

	hc.register({
		callback: function (e, hcb) {
			wry.route(e, hcb);
		},
		rule: new RegExp("^\!yt[0-9]+$")
	});
	$('.youtube_list, .search_results, .assoc_gallery_cont').on("click", ".youtube_popup", function () {
		location.hash = '!' + $(this).attr('id');
	});
}

/**
 * Videogallery (custom modulis) paieskos rezultatai ir pasiulymai: display_options.url yra itemdata JSON
 * (modules/videogallery/videogallerymodule.php searchIndexUpdate), todel video atidaromas fancybox'e
 * taip pat, kaip saraso elementai (videogallery_items.tpl: data-width=466 data-height=255).
 * Delegated handleris ant document, nes pasiulymus generuoja AngularJS.
 */
function videogallery_search_popup() {
	$(document).on('click', '.videogallery_search_popup', function (e) {
		e.preventDefault();
		$.getJSON($(this).data('url')).done(function (data) {
			if (!data || !data.view_url) {
				return;
			}
			$.fancybox.open({
				src: data.view_url,
				type: 'video',
				opts: {
					width: 466,
					height: 255
				}
			});
		});
	});
}

function getMoreNews(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: false
	}).done(function (html) {
		$('.news_list').append(html);
		imagesLoaded($('.news_list'), function () {
			$('.equalheight').responsiveEqualHeightGrid();
		});
		$('.loader_content').hide();
	});
}

function getMoreAlbums(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: false
	}).done(function (html) {
		$('.gallery_list').append(html);
		imagesLoaded($('.gallery_list'), function () {
			$('.equalheight').responsiveEqualHeightGrid();
		});
		$('.loader_content').hide();
	});
}

function getMoreVideos(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: false
	}).done(function (html) {
		$('.youtube_list').append(html);
		imagesLoaded($('.youtube_list'), function () {
//			$('.equalheight').responsiveEqualHeightGrid();
		});
		$('.loader_content').hide();
	});
}


var isMobile = {
	Android: function () {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function () {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function () {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera: function () {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function () {
		return navigator.userAgent.match(/IEMobile/i);
	},
	any: function () {
		return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
	}
};


function fixed_header() {
	$('.container-fluid').click(function () {
		$(".langs_drop_cont").slideUp("fast");
		$(".langs_cont").removeClass("dropped");
	});

	$(".current_lang_cont").click(function (e) {
		e.stopPropagation();
		$(this).parent().toggleClass("dropped");
		$(this).parent().find(".langs_drop_cont").slideToggle("fast");
	});

	// Fixes the fixed header in iOS
	if (isMobile.iOS()) {
		var $body;
		if ('ontouchstart' in window) {
			$body = $("body");
			document.addEventListener('focusin', function () {
				return $body.addClass("fixfixed");
			});
			return document.addEventListener('focusout', function () {
				$body.removeClass("fixfixed");
				return setTimeout(function () {
					return $(window).scrollLeft(0);
				}, 20);
			});
		}
	}

}

function print_v() {
	$(".print_button").click(function () {
		window.print();
	});
}

function highlight_search_results() {
	if ($('.search_results').length) {
		var query = $('.search_results').data('text');
		$(".search_results").highlight(query);
	}

}

var EwSiteApp = angular.module('EwSiteApp', [])
		.config(['$provide', function ($provide) {
				$provide.decorator('$browser', ['$delegate', function ($delegate) {
						$delegate.onUrlChange = function () {};
						$delegate.url = function () {
							return "";
						};
						return $delegate;
					}]);
			}]);
EwSiteApp.filter('u2date', ['$filter', function ($filter) {
	return function (udate) {
		var format = 'yyyy-MM-dd';
		if (arguments[1]) {
			format = arguments[1];
		}
		return $filter('date')(udate * 1000, format);
	};
}]);
EwSiteApp.controller('CommentsCtrl', ['$scope', '$http', '$attrs', '$log', function ($scope, $http, $attrs, $log) {
	$scope.postUrl = '';
	$scope.getUrl = '';
	$scope.hash_key = '';
	$scope.isconfirm = false;
	$scope.errors = [];
	$scope.comments = {
		list: []
	};
	$scope.all_displayed = false;

	$scope.clearCommentsForm = function () {
		$scope.comment.name = "";
		$scope.comment.email = "";
		$scope.comment.comment = "";
		$scope.errors = [];
		$scope.commentform.$setPristine();
	};

//jsonp -comentaru listui

	$scope.submit = function () {
		if ($scope.postUrl !== '') {
			$scope.isconfirm = false;
			$http({
				method: 'POST',
				url: $scope.postUrl + '?hash_key=' + $scope.hash_key,
				data: $scope.comment,
				xsrfCookieName: $scope.hash_key
			}).then(function (response) {
				if (response.data.data.success) {
					$scope.clearCommentsForm();
					$scope.isconfirm = response.data.data.isconfirm;
					if (!$scope.isconfirm) {
						$scope.getList(1);
					}
				} else if (angular.isDefined(response.data.data.messages)) {
//					$log.debug(data.data.message);
					$scope.errors = response.data.data.messages;
				}
				if (angular.isDefined(response.data.data.debug)) {
					$log.debug(response.data.data.debug);
				}
				if (!$scope.isconfirm) {
					$('html, body').animate({
						scrollTop: $(".comments_list").offset().top - 10
					}, 300);
				}
			}, function (response) {
				console.log(['Error', response]);
			});
		}
	};

	$scope.getList = function (getall) {
		if (getall == 1) {
			$scope.all_displayed = true;
		}
		if ($scope.getUrl !== '') {
			$http({
				method: 'GET',
				url: $scope.getUrl + '?getall=' + getall + ';hash_key=' + $scope.hash_key,
			}).then(function (response) {
				$scope.comments.list = response.data.list;
				if (getall == 0 && response.data.totalRows <= $scope.limit) {
					$scope.all_displayed = true;
				}
			}, function (response) {
				console.log(['Error', response]);
			});
		}
	};

	$scope.hasErrors = function () {
		return $scope.errors.length > 0;
	};




}]).directive('commentsContainer', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.postUrl = '';
			scope.getUrl = '';
			scope.hash_key = '';
			scope.limit = 10;
			if (attr.postUrl !== '') {
				scope.postUrl = attr.postUrl;
			}
			if (attr.id !== '') {
				scope.hash_key = attr.id;
			}
			if (attr.limit !== '') {
				scope.limit = attr.limit;
			}
			if (attr.getUrl !== '') {
				scope.getUrl = attr.getUrl;
				scope.getList(0);
			}

		}
	};
});

function init_questions_toggler_hash() {

	this.$ct = $('.category-title');
	this.$tt = $('.topic-title');
	this.offset = ($('.fixed_header').is(':visible')) ? 50 : 0;

	var self = this;

	this.getArgs = function () {
		var query = window.location.hash;
		query = query.substr(1)
		var args = new Array();
		query.split("/").forEach(function (part) {
			var item = part.split("-");
			args[item[0]] = item[1];
		});
		return args;
	};
	var args = this.getArgs();

	if (typeof args['c'] !== 'undefined') {
		$('[data-category-id="' + args['c'] + '"]').find('.category-title').attr('data-category-role', 'open').next('.topics').removeClass('hidden').addClass('visible');
		$('[data-category-id="' + args['c'] + '"]').next('.topics').slideDown("fast");
		$('html,body').animate({scrollTop: $('[data-category-id="' + args['c'] + '"]').offset().top - 10 - this.offset + 'px'}, 'fast');
	}

	if (typeof args['t'] !== 'undefined') {
		$('[data-topic-id="' + args['t'] + '"]').attr('data-topic-role', 'open').next('.topic-description').removeClass('hidden').addClass('visible');
		$('[data-topic-id="' + args['t'] + '"]').next('.topic-description').slideDown("fast");
		$('html,body').animate({scrollTop: $('[data-topic-id="' + args['t'] + '"]').offset().top - 10 - this.offset + 'px'}, 'fast');
	}

	this.hide = function (sel) {
		return sel.slideUp("fast").removeClass('visible').addClass('hidden');
	};

	this.show = function (sel) {
		return sel.slideDown("fast").removeClass('hidden').addClass('visible');
	};

	this.ctEvent = function () {
		this.$ct.click(function () {

			if ($(this).attr('data-category-role') === 'close') {
				var cur = $(this);

				self.hide(self.$ct.attr('data-category-role', 'close').next('.topics')).not($(this));
				self.hide(self.$tt.attr('data-topic-role', 'close').next('.topic-description'));
				self.show($(this).attr('data-category-role', 'open').next('.topics'));

				window.location.hash = '#c-' + $(this).attr('data-category-id');

			} else if ($(this).attr('data-category-role') === 'open') {

				self.hide(self.$ct.attr('data-category-role', 'close').next('.topics'));
				self.hide(self.$tt.attr('data-topic-role', 'close').next('.topic-description'));
				self.hide($(this).attr('data-category-role', 'close').next('.topics'));
				history.pushState("", document.title, window.location.pathname + window.location.search);

			}
		});
	};

	this.ttEvent = function () {
		this.$tt.click(function () {
			if ($(this).attr('data-topic-role') === 'close') {
				var cur = $(this);
				self.hide($('.no-topics')).prev('.category-title').attr('data-category-role', 'close');

				self.hide(self.$tt.parent('.topics:not(.show)').not($(this).parent()));
				self.$tt.parent().prev('.category-title').not($(this).parent().prev('.category-title')).attr('data-category-role', 'close');
				self.hide(self.$tt.not($(this)).attr('data-topic-role', 'close').next('.topic-description').not($(this).next('.topic-description')));

				self.show($(this).attr('data-topic-role', 'open').next('.topic-description'));

				history.pushState("", document.title, window.location.pathname + window.location.search + '#c-' + $(this).attr('data-category-id') + '/' + 't-' + $(this).attr('data-topic-id'));

			} else if ($(this).attr('data-topic-role') === 'open') {

				self.hide($('.no-topics')).prev('.category-title').attr('data-category-role', 'close');

				self.hide(self.$tt.parent('.topics:not(.show)').not($(this).parent()));
				self.$tt.parent().prev('.category-title').not($(this).parent().prev('.category-title')).attr('data-category-role', 'close');
				self.hide(self.$tt.not($(this)).attr('data-topic-role', 'close').next('.topic-description').not($(this).next('.topic-description')));

				self.hide($(this).attr('data-topic-role', 'close').next('.topic-description'));

				window.location.hash = '#c-' + $(this).attr('data-category-id');
			}
		});
	};

	this.initEvents = function () {
		this.ctEvent();
		this.ttEvent();
	};

	this.initEvents();

}

function catalog_gallery() {
	$(".catalog_gallery a").click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		$(".catalog_gallery a").removeClass("active_ph");
		$(this).addClass("active_ph");
		$("a.full_photo_preview").removeClass("current_photo");
		$(".main_photo a.photo" + $(this).data("href")).addClass("current_photo");
	});
}


function file_input() {
	$("input[type=file]").nicefileinput({});
}

function mobile_overflow_tables() {
	if ($(".content_template").length) {
		$('.content_template table').each(function () {
			var element = $(this);
			// Create the wrapper element
			var scrollWrapper = $('<div />', {
				'class': 'scrollable',
				'html': '<div />' // The inner div is needed for styling
			}).insertBefore(element);
			// Store a reference to the wrapper element
			element.data('scrollWrapper', scrollWrapper);
			// Move the scrollable element inside the wrapper element
			element.appendTo(scrollWrapper.find('div'));
			// Check if the element is wider than its parent and thus needs to be scrollable
			if (element.outerWidth() > element.parent().outerWidth()) {
				element.data('scrollWrapper').addClass('has-scroll');
			}
			// When the viewport size is changed, check again if the element needs to be scrollable
			$(window).on('resize orientationchange', function () {
				if (element.outerWidth() > element.parent().outerWidth()) {
					element.data('scrollWrapper').addClass('has-scroll');
				} else {
					element.data('scrollWrapper').removeClass('has-scroll');
				}
			});
		});
	}
}

EwSiteApp.service("ajaxSearch", ['$http', '$q', function ($http, $q) {
	return({
		search: search
	});

	function search(url) {
		var cfg = {
			method: 'GET',
			url: url
		};
		if (arguments[1]) {
			cfg.params = arguments[1];
		}
		var request = $http(cfg);
		return(request.then(succesHandler, errorHandler));
	}
	;

	function succesHandler(response) {
		return response.data;
	}

	function errorHandler(response) {
		if (!angular.isObject(response.data) || !response.data.message) {
			return($q.reject("An unknown error occurred."));
		}
		return($q.reject(response.data.message));
	}
	;
}]);

EwSiteApp.controller('SuggestSearchCtrl', ['$scope', '$log', 'ajaxSearch', function ($scope, $log, ajaxSearch) {
	$scope.searchUrl = '';
	$scope.sdquery = '';
	$scope.searchresults = [];
	$scope.total = 0;
	$scope.search_url = '';
	$scope.templates = {
		title_description: 'search/title_description.html',
		img_title: 'search/img_title.html',
		img_title_description: 'search/img_title_description.html',
		module_gallery: 'search/module_gallery.html',
		module_youtubegallery: 'search/module_youtubegallery.html',
		module_videogallery: 'search/module_videogallery.html',
	};
	$scope.str_len = 100;

	$scope.find = function () {
		if ($scope.searchUrl !== '') {
			ajaxSearch.search($scope.searchUrl, {sdquery: $scope.sdquery}).then(function (results) {
				if ($scope.sdquery === '') {
					$scope.clear();
				} else {
					$scope.displaySuggestions(results);
					$scope.total = results.total;
					$scope.search_url = results.search_url;

				}
			}, function (response) {
				$log.error(response);
			});
		}
	};
	$scope.displaySuggestions = function (results) {
		$scope.searchresults = results.data;
	};
	$scope.clear = function () {
		$scope.sdquery = '';
		$scope.total = 0;
		$scope.displaySuggestions([]);
	};
	$scope.getDataTemplate = function (data) {
		if (data.module === 'gallery' || data.module === 'photoalbums') {
			data.display_options.template.id = 'module_gallery';
		}
		if (data.module === 'youtubegallery') {
			data.display_options.template.id = 'module_youtubegallery';
		}
		if (data.module === 'videogallery') {
			data.display_options.template.id = 'module_videogallery';
		}
		if (typeof (data.display_options.template.id) !== 'undefined' && typeof ($scope.templates[data.display_options.template.id]) !== 'undefined') {
			return $scope.templates[data.display_options.template.id];
		}
		return $scope.templates.title_description;
	};
	$scope.changeLocationHash = function (data, name, varname) {
		var hash = '!' + name + data.display_options.vars[varname];
		location.hash = hash;
	};
}]).directive('suggestSearchContainer', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.searchUrl = '';
			if (attr.searchUrl !== '') {
				scope.searchUrl = attr.searchUrl;
			}
		}
	};
});

function iframe_adaptability() {

	var $container = $(".content_template");
	var $iframes = $("iframe");

	$container.find($iframes).each(function () {
		$(this).wrap("<div class='iframe_wrapper'></div>");
	});
}

function getMoreInstagramPhotos(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: true
	}).done(function (html) {
		$('.instagram_list').append(html);
		$('.loader_content').hide();
	});
}


function reportbug_form() {
	if ($("#reportbug_form_wrapper").length) {
		$(".reportbug_link a").fancybox({
			type: "inline",
			padding: [55, 10, 30, 20],
			margin: [10, 0, 10, 0],
			afterClose: function () {
				$(".bugreport_form").find(".bugreport_form_infos").hide();
				$(".bugreport_form").find(".one_item").show();
				$(".bugreport_form").find(".reportbug_submit").show();
				$(".bugreport_form").find(".phpcaptcha_container").show();
			}
		});

		$(".bugreport_form").validate({
			highlight: function (element, errorClass, validClass) {
				if ($(element).closest(".type_item").length) {
					$(element).closest(".type_item").removeClass(validClass).addClass(errorClass);
				}
			},
			unhighlight: function (element, errorClass, validClass) {
				if ($(element).closest(".type_item").length) {
					$(element).closest(".type_item").removeClass(errorClass).addClass(validClass);
				}
			},
			errorPlacement: function (error, element) {
				$(element).closest(".type_item").find('.type_error').append(error);
			},
			submitHandler: function (form) {
				if ($(".bugreport_form").hasClass("currently_sending")) { // if btn inactive
					return false;
				}
				var data = $(form).serialize();
				var url = $(form).data("url");
				var $form = $(".bugreport_form");
				$form.addClass("currently_sending");
				$.ajax({
					type: "POST",
					url: url,
					data: data,
					success: function (data) {
						$form.removeClass("currently_sending");
						var $infoc = $(".bugreport_form_infos");
						$infoc.find(".info_cont").fadeOut("fast").html();
						$infoc.find(".error_cont").fadeOut("fast");
						$infoc.find(".error_cont .errors_list").html();
						if ($(".phpcaptcha_container", $form).length) {
							var captchasrc = $form.find("#captcha_value_image").attr("src");
							$form.find("#captcha_value_image").attr("src", captchasrc.split("?")[0] + "?r=" + Math.random());
						}
						if (!data.data.success) {
							$infoc.fadeIn("fast");
							$infoc.find(".error_cont").fadeIn("fast").find(".errors_list").html('<p>' + data.data.errors.join("</p><p>") + '</p>');
							$(".fancybox-inner").animate({scrollTop: 0 + 'px'}, 'fast');

						} else {
							$infoc.fadeIn("fast");
							$infoc.find(".info_cont").fadeIn("fast").html('<p>' + data.data.message + '</p>');
							$form.find("input").not("[name=SITEXSRF]").val('');
							$form.find("textarea").val('');
							$form.find(".one_item").fadeOut("fast");
							$form.find(".reportbug_submit").fadeOut("fast");
							$form.find(".phpcaptcha_container").fadeOut("fast");
						}
					}
				});
				return false;
			}
		});
	}
}

function show_more() {
	$('.blocks_container').find('.show_more').click(function () {
		$(this).toggleClass('active');
		$(this).parent('.text_container').next('.block_more_info').slideToggle('fast').toggleClass('open');
	});

	$('.blocks_container').find('.show_less').click(function () {
		$(this).parents('.single_block').find('.show_more').removeClass('active');
		$(this).parent('.block_more_info').slideUp('fast').removeClass('open');
	});

	$('.videos_list').find('.show_video_desc').click(function () {
		$(this).toggleClass('active');
		$(this).next('.resource_video_desc').slideToggle('fast');
	});
}

function postformwidget_validate() {
	var $form = $("#postformwidget_form");
	if ($form.length) {
		$form.validate({
			submitHandler: function (form) {
				if ($form.hasClass("currently_sending")) {
					return false;
				}
				var data = $(form).serialize();
				var url = $(form).data("url");
				$form.addClass("currently_sending");
				$.ajax({
					type: "POST",
					url: url,
					data: data,
					success: function (data) {
						$form.removeClass("currently_sending");
						var $infoc = $(".postformwidget_infos");
						$infoc.find(".info_cont").fadeOut("fast").html();
						$infoc.find(".error_cont").fadeOut("fast");
						$infoc.find(".error_cont .errors_list").html();
						if (!data.data.success) {
							$infoc.fadeIn("fast");
							$infoc.find(".error_cont").fadeIn("fast").find(".errors_list").html('<p>' + data.data.errors.join("</p><p>") + '</p>');
						} else {
							$infoc.fadeIn("fast");
							$infoc.find(".info_cont").fadeIn("fast").html('<p>' + data.data.message + '</p>');
							$form.find("input").val('');
							$form.find("textarea").val('');
							$form.find(".input_holder").fadeOut("fast");
							$form.find(".contact_block_title").fadeOut("fast");
							$form.find(".recaptcha_cont").fadeOut("fast");
							$form.find(".button_holder").fadeOut("fast");
							setTimeout(function () {
								$(window).trigger('resize');
							}, 450);
						}
					}
				});
				return false;
			}
		});
	}
}

function init_contacts() {
	if ($(".contacts_struct_cont").length) {
		$('#search_by_field').change(function () {
			$('#search_by_label').text($("#search_by_field option[value='" + $(this).val() + "']").text());
		});
	}
}

/**
 * Google reCAPTCHA v3 palaikymas klasikinems (ne AJAX) formoms.
 * recaptcha/recaptcha.tpl v3 atveju isveda <input type="hidden" id="g-recaptcha-response-hidden" data-sitekey="...">.
 * Pries siuntima gaunamas tokenas ir irasomas i si lauka; jQuery Validate submit handleris suveikia anksciau,
 * todel neteisinga forma cia nepatenka.
 */
function recaptcha_v3() {
	var $hidden = $('#g-recaptcha-response-hidden');
	if (!$hidden.length) {
		return;
	}
	var $form = $hidden.closest('form');
	if (!$form.length || $form.attr('ng-submit')) {
		return;
	}
	// bindinama po validate(), todel jQuery Validate handleris suveikia pirmas ir neteisingai formai jau buna iskvietes preventDefault
	$form.on('submit', function (e) {
		if (e.isDefaultPrevented() || $hidden.val() !== '' || typeof (grecaptcha) === 'undefined') {
			return;
		}
		e.preventDefault();
		var form = this;
		grecaptcha.ready(function () {
			grecaptcha.execute($hidden.data('sitekey'), {action: 'submit'}).then(function (token) {
				$hidden.val(token);
				form.submit();
			}, function () {
				form.submit();
			});
		});
	});
}

/**
 * Formu datos laukai (forms 7 tipo laukas su class="datepicker", readonly) - be datepicker'io ju uzpildyti neimanoma.
 * Perimta is EW4 bazes app/script.js.
 */
function pikaday() {
	var datePickerElements = document.querySelectorAll('.datepicker');
	datePickerElements.forEach(function (datePickerElement) {
		new Pikaday({
			field: datePickerElement,
			format: 'YYYY-MM-DD',
			firstDay: 1,
			autocomplete: false,
			showDaysInNextAndPreviousMonths: false,
			toString: function (date) {
				return dayjs(date).format('YYYY-MM-DD');
			},
			parse: function (dateString) {
				return dayjs(dateString, 'YYYY-MM-DD').toDate();
			},
			i18n: {
				previousMonth: '',
				nextMonth: '',
				months: dayjs.localeData().months(),
				weekdays: dayjs.localeData().weekdays(),
				weekdaysShort: dayjs.localeData().weekdaysShort()
			}
		});
	});
}

// http://iamceege.github.io/tooltipster/
function tooltipster() {
	if ($(".tooltip").length) {
		$('.tooltip').tooltipster({
			delay: 15
		});
	}
}
/** EUCOOKIE */

EwSiteApp.controller('EuCookieCtrl', ['$scope', '$http', '$attrs', '$log', function ($scope, $http, $attrs, $log) {
	$scope.data = {};
	$scope.state = 0;
	$scope.pop = false;
	$scope.showLine = true;
	$scope.message = '';
	$scope.loading = false;
	$scope.error = false;

	if ($scope.state == 1) {
		$scope.showLine = false;
	}
	$scope.hiddeLine = function () {
		$scope.showLine = false;
	};
	$scope.closePopup = function () {
		$scope.pop = false;
	};
	$scope.showPop = function () {
		$scope.pop = !$scope.pop;
	};
	$scope.storeChoises = function () {
		$scope.loading = true;

		$http({
			method: 'POST',
			url: unescape($attrs.storeUrl),
			data: $scope.data,
			xsrfCookieName: secure_xsrf_name,
			xsrfHeaderName: 'X-' + secure_xsrf_name
		}).then(function (response) {
			if (typeof (response.data.message) !== 'undefined' && response.data.message) {
				$scope.message = response.data.message;
				$scope.loading = false;
				$scope.closePopup();
				$scope.hiddeLine();
			} else {
				$scope.error = true;
				$scope.loading = false;
			}
			// eucookie >= 1.2.0: po sutikimo grazinami leidziami embed kodai (collection) arba reload pozymis
			if (typeof (response.data.reload) !== 'undefined' && response.data.reload) {
				reloadPage();
			}
			if (typeof (response.data.collection) !== 'undefined') {
				loadCollection(response.data.collection);
			}
		}, function (response) {
			console.log(['Error', response]);
		});
	};

	function loadCollection(collection) {
		if (!collection || typeof (collection.head) === 'undefined' || !collection.head.length) {
			return;
		}
		var ifr = document.createElement('iframe');
		ifr.style.display = 'none';
		document.body.appendChild(ifr);
		for (var i = 0; i < collection.head.length; i++) {
			ifr.contentDocument.head.innerHTML += collection.head[i];
		}
		var nodes = ifr.contentDocument.head.childNodes;
		for (var j = 0; j < nodes.length; j++) {
			var nod = nodes[j];
			if (nod.nodeType !== 1) {
				continue;
			}
			var ss = document.createElement(nod.tagName);
			for (var k = 0; k < nod.attributes.length; k++) {
				ss.setAttribute(nod.attributes[k].nodeName, nod.attributes[k].nodeValue);
			}
			ss.innerText = nod.innerText;
			document.head.appendChild(ss);
		}
		document.body.removeChild(ifr);
	}

	function reloadPage() {
		location.reload();
	}
}]);

function sidebar_menu() {
	if ($(".submenu_block").length > 0) {
		var $parent = $(".submenu_block");
		var $icons = $parent.find('.icon-chevron-down');

		if ($icons.length > 0) {
			$icons.each(function () {
				var sliding = false;

				$(this).click(function (e) {
					e.preventDefault();

					if (!sliding) {
						sliding = true;

						if (!$(this).parents('li').hasClass('show')) {
							$(this).parents('ul').children('li.show').removeClass('show').children('ul').slideUp(150);
							$(this).parents('ul').children('li').removeClass('prev next');
						}

						$(this).parents('li').toggleClass('show').removeClass('prev next');
						$(this).parents('li').prev().toggleClass('prev');
						$(this).parents('li').next().toggleClass('next');
						$(this).parent().next().slideToggle(150, function () {
							sliding = false;
						});
					}
				});
			});
		}
	}
}

function scroll_top() {
	if ($('.scroll_top').length > 0) {
		$('.scroll_top button').click(function () {
			$('html, body').animate({
				scrollTop: 0
			}, 300);
		});
	}
}

// titlepage calendar
var calendar_data = {
	baseurl: '',
	month: ''
};

function set_widgetcalendar_data() {
	calendar_data.baseurl = $('#widget_calendar').data('baseurl');
	calendar_data.month = $('#widget_calendar').data('month');
}

function getCalendarMonth(month) {
	loadMonth(month);
}

function loadMonth(month) {
	calendar_data.month = month;
	loadCalendar();
}

function loadCalendar() {
	$.ajax({
		url: calendar_data.baseurl + '/' + calendar_data.month,
		cache: false
	}).done(function (html) {
		$('#events_calendar').html(html);
		showDayEvent();
		showCurrentMonthEvents();
	});
}

function showDayEvent() {
	var activeDay = $('#widget_calendar .calendar_container .day.active');
	var $calendar_cont = $('.events_calendar_block');

	if ($("#widget_calendar .calendar_container").length > 0) {
		activeDay.each(function () {
			var $day = $(this);
			$day.on("click", function (e) {
				e.stopPropagation();
				activeDay.removeClass('selected');
				$day.addClass('selected');
				$calendar_cont.find('.firstload').hide();
				$calendar_cont.find('.day_events').hide();
				$calendar_cont.find('.day_events[data-selected-day="' + $day.data('day') + '"]').show();
			});
		});
	}
}

function showCurrentMonthEvents() {
	var days = document.querySelectorAll('.items_list .day_events');
	var i = 0;
	var event_list = [];

	for (i; i < days.length; i++) {
		var dataid = days[i].getAttribute('data-id');
		var includes = event_list.includes(dataid);

		if (null !== dataid && !includes) {
			days[i].classList.add('show');
			event_list.push(dataid);
		}
	}

	if (event_list.length < 1) {
		showNoEventMessage();
	}
}

function showNoEventMessage() {
	var container = document.querySelector('.section_events .items_list');
	if (null !== container) {
		var element = document.createElement('span');
		element.innerHTML = (typeof window.no_events !== 'undefined') ? window.no_events : '';
		element.classList.add('no_tasks');
		container.appendChild(element);
	}
}

function EventCalendar(params) {
	var self = this;
	var calendar = {
		calendar_query: {
			category_id: 0,
			location_id: 0,
			month: '', //$("#content_calendar").attr('data-month')
			innerpage: 1,
			year: 0,
		},
		calendar_data: {
			baseurl: '',
			month: '',
			day: ''
		}
	};

	calendar.init = function () {
		calendar.set_widgetcalendar_data();
		calendar.calendarFilters();
//		calendar.calendarPaginate();
		calendar.showDayEventInner();
		calendar.changeMonth();
	};


	calendar.set_widgetcalendar_data = function () {
		calendar.calendar_data.baseurl = $('#widget_calendar').data('baseurl');
		calendar.calendar_data.month = $('#widget_calendar').data('month');
	};

	calendar.changeMonth = function () {
		$('.eventscalendar_list .prev_month, .eventscalendar_list .next_month').click(function () {
			calendar.getCalendarMonthInner($(this).attr('data-id'));
		});
	};

	calendar.getCalendarMonthInner = function (month) {
		calendar.calendar_query.month = month;
		calendar.loadMonthInner();
	};

	calendar.loadMonthInner = function () {
		calendar.loadCalendarInner();
	};

	calendar.calendarFilters = function () {
		$(".filters .categories").change(function () {
			calendar.calendar_query.category_id = $(this).val();
			calendar.loadMonthInner();
		});

		$(".filters .locations").change(function () {
			calendar.calendar_query.location_id = $(this).val();
			calendar.loadMonthInner();
		});

		$(".filters .years").change(function () {
			calendar.calendar_query.year = $(this).val();
			calendar.getCalendarMonthInner($(this).val());
		});

		$(".filters .limit").change(function () {
			$(".filters .limit .item").removeClass('active');
			$(this).addClass('active');
			calendar.calendarPaginate($(this).val());
		});
	};

	calendar.clearCalendarFilters = function () {
		calendar.calendar_query.location_id = 0;
		calendar.calendar_query.year = 0;
		calendar.calendar_query.month = '';
		calendar.calendar_query.category_id = 0;
		calendar.loadMonthInner();
	}

	calendar.initClearCalendarFiltersBtn = function () {
		var btns = document.querySelectorAll('.filters .clear_filter');
		if (null === btn) {
			return;
		}

		for (var i = 0; i < btns.length; i++) {
			var btn = btns[i];
			btn.addEventListener('click', calendar.clearCalendarFilters);
		}
	};

	calendar.loadCalendarInner = function (month) {
		var $calendar_cont = $('#content_calendar');
		var url = $calendar_cont.data('baseurl');
		var url_month = calendar.calendar_query.month;
		if (url_month == '') {
			url_month = $("#content_calendar").attr('data-month');
		}
		var ajaxUrl = url + '/' + url_month;//calendar.calendar_query.month
		$.ajax({
			url: ajaxUrl,
			cache: false,
			data: calendar.calendar_query
		}).done(function (html) {
			$calendar_cont.html(html).promise().done(function (arg1) {
				$('.eql_event').responsiveEqualHeightGrid();
				select2();
				toggle_items();
			});
			calendar.showDayEventInner();
			calendar.changeMonth();
			calendar.initClearCalendarFiltersBtn();
		});
	};

	calendar.showDayEventInner = function (fromAjax) {
		var $calendar_cont = $('#content_calendar');
		var loader = $('#content_calendar').find('.loader_item');
		loader.hide();

		if ($calendar_cont.length > 0 && $("#events_calendar").length > 0) {
			$('.day_withevents.active .day_number').each(function () {
				$(this).on("click", function (e) {
					e.stopPropagation();
					var $tm;
					var $day = $(this);
					clearTimeout($tm);
					$('.day_withevents.active').removeClass('selected');
					$(this).parent().addClass('selected');
					$calendar_cont.find('.day_events:not(.calendar_item):not(.loader_item):not(.empty_item)').hide();
					$('.pagination-container').hide();
					loader.show();
					calendar.calendar_data.day = $day.data('day');
					$tm = setTimeout(function () {
						loader.hide();
						$calendar_cont.find('.day_events[data-selected-day="' + $day.data('day') + '"]').show();
						calendar.calendarPaginate();
					}, 300);

				});
			});

			if ($('.day_withevents.active.current').length > 0) {
				$('.day_withevents.active.current .day_number').trigger('click').addClass('open');
			} else if ($('.day_withevents.active').length > 0) {
				$($('.day_withevents.active .day_number')[0]).trigger('click').addClass('open');
			}

			calendar.calendarFilters();
		}

	};

	calendar.calendarPaginate = function (perpage) {
		if ($('.eventscalendar_list .list').length > 0 && calendar.calendar_data.day) {

			$(".eventscalendar_list .pagination-container").remove();

			if (typeof (perpage) === 'undefined') {
				var perpage = $("#content_calendar").attr('data-perpage');
			}
			$('.eventscalendar_list .list .day_events[data-selected-day="' + calendar.calendar_data.day + '"]').paginathing({
				perPage: perpage,
				firstLast: false,
				prevText: "&lsaquo;",
				nextText: '&rsaquo;'
			});
		}
	};

	calendar.init();
}

function loadTitlepageCalendar() {
	if ($('.tp_widget_calendar').length > 0 && typeof $('.tp_widget_calendar').data('month') !== 'undefined' && $('.tp_widget_calendar').data('month') !== '') {
		getCalendarMonth($('.tp_widget_calendar').data('month'));
	}
}

function toggle_items() {
	$('.btn_toggle').click(function () {
		$(this).parent().parent().find('.toggle_content').toggleClass('active');
		$(this).toggleClass('rotate');
	});
}

function add_label_to_mobile_menu_buttons() {
	var container = document.getElementById('mobile_menu');
	if (container === null) {
		return;
	}

	var btns_list = container.querySelectorAll('.mm-next');
	for (var i = 0; i < btns_list.length; i++) {
		var btn = btns_list[i];
		btn.setAttribute('aria-label', 'Show more elements of nav');
	}
}


// webpack modulio funkcijos nera globalios - eksportuojame tas, kurias kviecia sablonai (onclick) ar kitas ne-bundle JS
window.getMoreNews = getMoreNews;
window.getMoreVideos = getMoreVideos;
window.getMoreAlbums = getMoreAlbums;
window.hc = hc;
window.isMobile = isMobile;
